var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"disabled":_vm.dis,"items":_vm.options,"item-text":"Label","item-value":"Value"},on:{"input":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('template',{slot:"label"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }